export enum ProductType {
  MORTGAGE = 'productTypeMortgage',
  CASH = 'productTypeCash',
  SME = 'productTypeSme',
  NONBANK = 'productTypeNonBank',
  REAL_ESTATE = 'productTypeRealEstate',
  INSURANCE = 'productTypeInsurance',
  FACTORING = 'productTypeSmeFactoring',
  LEASING = 'productTypeSmeLeasing',
  INVESTMENT = 'productTypeInvestment',
  LIFE_INSURANCE = 'productTypeInsuranceLife',
  VEHICLE_INSURANCE = 'productTypeInsuranceVehicle',
  ASSETS_INSURANCE = 'productTypeInsuranceAssets',
  MEDICAL_INSURANCE = 'productTypeInsuranceMedical',
}
